// Images constants
export const LARGE_IMAGE_WIDTH = '356px';
export const BASE_IMAGE_WIDTH = '276px';
export const SMALL_IMAGE_WIDTH = '216px';

// Cards constants
export const CARD_MIN_HEIGHT = '260px';
export const CARD_MIN_HEIGHT_HO = '260px';

// Overlay cards constants
export const OVERLAY_MIN_HEIGHT = '248px';
export const OVERLAY_WIDTH = '320px';
export const OVERLAY_WIDTH_EVOLUTION = '310px';

// Price constants
export const PRICE_WIDTH_SMALL = '224px';
export const PRICE_WIDTH_LARGE = '264px';

// breakpoint
export const CARD_MOBILE_BREAKPOINT = '768px';
export const CARD_CONTAINER_QUERY_BREAKPOINT = '788px';

export const CARD_DESKTOP_ROUNDING = '16px';
export const CARD_MOBILE_ROUNDING = CARD_DESKTOP_ROUNDING;
